// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"1c43a675","213":"7a48aad1","239":"b872c0ca","453":"ffeed20c"}[chunkId] + ".chunk.js";
};